import { Component, effect, inject, input, signal, untracked } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { Textarea } from 'primeng/textarea';
import { AideService } from '../../aide.service';

type Etape = 'question' | 'commentaire' | 'envoi' | 'merci' | 'erreur';

/**
 * « Ça vous a aidé ? » en bas d'un tuto. Oui : envoyé tout de suite. Non : on
 * demande ce qui a manqué (facultatif) avant d'envoyer. Une fois par tuto et
 * par session ; l'API garde un avis par utilisateur et par tuto.
 */
@Component({
  selector: 'app-aide-avis',
  standalone: true,
  imports: [FormsModule, ButtonModule, Textarea],
  templateUrl: './aide-avis.component.html',
  styleUrl: './aide-avis.component.scss',
})
export class AideAvisComponent {
  private readonly aide = inject(AideService);

  readonly slug = input.required<string>();
  readonly etape = signal<Etape>('question');
  commentaire = '';

  constructor() {
    // Le même composant sert au tuto suivant (« Et ensuite ? ») : on repart de zéro.
    effect(() => {
      const slug = this.slug();
      untracked(() => {
        this.commentaire = '';
        this.etape.set(this.aide.avisDonne(slug) ? 'merci' : 'question');
      });
    });
  }

  repondre(utile: boolean): void {
    if (utile) {
      this.envoyer(true);
    } else {
      this.etape.set('commentaire');
    }
  }

  envoyer(utile: boolean): void {
    const slug = this.slug();
    this.etape.set('envoi');
    this.aide.donnerAvis(slug, utile, utile ? undefined : this.commentaire).subscribe({
      next: () => slug === this.slug() && this.etape.set('merci'),
      error: () => slug === this.slug() && this.etape.set('erreur'),
    });
  }
}
